import cartActions from 'store/v2/redux/actions/cart'
import brandingUtils from 'ui/themes/utils'
import TimeUtils from 'shared/utils/time'
import Model from 'store/v2/redux/models'
import cartUtils from 'shared/utils/cart'
import OperatingRuleUtils from 'shared/utils/operating_rules'
import getBrandingColor from 'shared/utils/getBrandingColor'

const initializeDefaultTimes = (store) => {
  const defaultStartTime = TimeUtils.defaultStartTime()

  const defaultStopTime = TimeUtils.defaultStopTime({
    defaultStartTime
  })

  // If we don't use times and have a fixed start time
  // we use this as the first selectable date, it would
  // not pass validation anyway
  const state = store.getState()
  const startType = state.settings.get('orders.start_type')
  const useTimes = state.settings.get('store.period_type') === 'timeslot_fixed' ?
    true :
    state.settings.get('store.use_times')

  let firstTimeSelectable

  if (startType === 'fixed' && !useTimes) {
    firstTimeSelectable = defaultStartTime
  } else {
    firstTimeSelectable = OperatingRuleUtils.firstTimeSelectable()
  }

  store.dispatch({
    type: 'DEFAULT_TIMES_INITIALIZED',
    payload: {
      defaultStartTime,
      defaultStopTime,
      firstTimeSelectable
    }
  })
}

const clientActions = {
  initialize () {
    const store = window.booqableGetStore()

    return cartActions.fetch({
      source: 'store',
      embeddable_cart_elements: window.booqableOptions?.embeddableCartElements,
      apiVersion: 1
    }).then(function (action) {
      store.dispatch({ type: 'SETTINGS_INITIALIZED', payload: { settings: action.payload.response.meta.settings } })

      // Operating rules
      Model.OperatingRule.hydrate({ operating_rules: action.payload.response.meta.operating_rules })

      // Locations
      Model.Location.hydrate({ locations: action.payload.response.meta.locations })

      // Overdue cart check
      clientActions.evaluateCartOverdue()

      // Get branding color from theme or from settings
      const brandingColor = getBrandingColor()

      brandingUtils.insertCSS(brandingColor)

      // Do this async to speed up initialization
      new Promise((resolve, _reject) => {
        initializeDefaultTimes(store) && resolve()
      })

      return store.dispatch({ type: 'TRANSLATIONS_INITIALIZED' })
    })
  },

  setFloatingCart () {
    const store = window.booqableGetStore()

    return store.dispatch({
      type: 'SET_FLOATING_CART',
      payload: {
        floatingCart: true
      }
    })
  },

  toggleCart (open) {
    const store = window.booqableGetStore()

    return store.dispatch({
      type: 'TOGGLE_CART',
      payload: {
        cartOpen: open
      }
    })
  },

  toggleModalPicker (open) {
    const store = window.booqableGetStore()

    // Legacy picker support
    store.dispatch({
      type: 'TOGGLE_PICKER',
      payload: {
        modalPickerOpen: open
      }
    })

    return store.dispatch({
      type: open ? 'CART_OPEN' : 'CART_CLOSE'
    })
  },

  setCartScroll (pixels) {
    const store = window.booqableGetStore()

    return store.dispatch({
      type: 'SET_CART_SCROLL',
      payload: {
        cartScroll: pixels
      }
    })
  },

  setCheckingOut () {
    const store = window.booqableGetStore()
    const state = store.getState()

    store.dispatch({
      type: 'SET_CHECKING_OUT'
    })

    const cartId = state.client.get('cartId')
    const cart = state.orm.carts.getById(cartId)

    let checkoutURL = cart?.checkout_url
    const booqableOptions = window.booqableOptions

    if (checkoutURL && booqableOptions.checkoutDomain) {
      // Make sure we enforce SSL
      const domain = checkoutURL.match(/(https|http):\/\/(.*)\/checkout/)[2]

      checkoutURL = checkoutURL.replace(domain, booqableOptions.checkoutDomain)
    }

    const checkoutURLwithSearch = window.Booqable.decorateLinkForTracking(`${checkoutURL}${window.location.search}`)

    store.dispatch({
      type: 'SET_CHECKING_OUT',
      payload: false
    })

    window.location = checkoutURLwithSearch
  },

  setCartId (id) {
    const store = window.booqableGetStore()

    return store.dispatch({
      type: 'SET_CART_ID',
      payload: {
        cartId: id
      }
    })
  },

  evaluateCartOverdue () {
    const store = window.booqableGetStore()
    const state = store.getState()

    const cartId = state.client.get('cartId')
    const cart = state.orm.carts.getById(cartId)

    const overdue = cartUtils.isOverdue(cart)

    store.dispatch({ type: 'SET_CART_OVERDUE', payload: overdue })

    return overdue
  }
}

export default clientActions
